import React from 'react';

import { SectionSubtitle } from 'components/FormHelper/SectionSubtitle';
import PropTypes from 'prop-types';

import { formatDateTime } from 'utils/DatesUtils';

export const MessageHeader = ({ senderLabel, timestamp }) => (
  <div className="message-header">
    <SectionSubtitle>{senderLabel}</SectionSubtitle>
    {timestamp && (
      <span className="message-header__timestamp">{formatDateTime(timestamp)}</span>
    )}
  </div>
);

MessageHeader.propTypes = {
  senderLabel: PropTypes.string.isRequired,
  timestamp: PropTypes.string,
};

MessageHeader.defaultProps = {
  timestamp: null,
};
